/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/js/Map.js
class Map {
  constructor() {
    this.mapSelector = '.wq-map';
    this.googleMapSelector = '.wq-map__gmap';
    this.map = null;
    this.marker = null;
    this.geocoder = null;
  }

  init = async () => {
    this.mapElement = document.querySelector(this.mapSelector);
    if (!this.mapElement) return;

    this.options = JSON.parse(
      this.mapElement.getAttribute('data-section-settings')
    );

    if (!this.options.mapAddress) {
      console.warn('Map: Missing map address');
      return;
    }

    this.initMap();
  };

  initMap = async () => {
    const { Map } = await google.maps.importLibrary('maps');
    this.geocoder = new google.maps.Geocoder();

    this.geocoder.geocode(
      { address: this.options.mapAddress },
      (results, status) => {
        if (status !== google.maps.GeocoderStatus.OK) {
          console.warn('Map: Geocoding failed', status);
          return;
        }

        const mapOptions = {
          zoom: this.options.zoom,
          center: results[0].geometry.location,
          draggable: false,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          disableDefaultUI: true,
          mapId: '22443d1044195d2d3cd80181',
        };

        this.map = new Map(
          this.mapElement.querySelector(this.googleMapSelector),
          mapOptions
        );

        this.addMarker(results[0].geometry.location);
        this.applyMapStyle();
        this.setupResizeHandler();
      }
    );
  };

  addMarker = async (position) => {
    const { AdvancedMarkerElement, PinElement } =
      await google.maps.importLibrary('marker');

    const pin = new PinElement({
      glyphColor: 'white',
      borderColor: 'white',
      background: this.options.markerColor,
    });

    this.marker = new AdvancedMarkerElement({
      map: this.map,
      position: position,
      content: pin.element,
    });
  };

  applyMapStyle = () => {
    const styleElement = this.mapElement.querySelector('[data-gmap-style]');
    if (!styleElement) return;

    const mapStyle = JSON.parse(styleElement.innerHTML);
    const styledMapType = new google.maps.StyledMapType(mapStyle);

    this.map.mapTypes.set('styled_map', styledMapType);
    this.map.setMapTypeId('styled_map');
  };

  setupResizeHandler = () => {
    const center = this.map.getCenter();

    window.addEventListener('resize', () => {
      google.maps.event.trigger(this.map, 'resize');
      this.map.setCenter(center);
    });
  };
}

;// ./src/js/ProductInfo.js
class ProductInfo {
  constructor() {
    this.moreInfoTextSelector = '.product-info__more-info--text';
    this.moreInfoImageSelector = '.product-info__more-info--image';
    this.moreInfoHideSelector = 'product-info__more-info--hide';
    this.productGallerySelector = '#product-gallery';
  }

  init = () => {
    this.moreInfoText = document.querySelector(this.moreInfoTextSelector);
    this.moreInfoImage = document.querySelector(this.moreInfoImageSelector);
    this.productGallery = document.querySelector(this.productGallerySelector);

    if (!this.moreInfoText || !this.moreInfoImage || !this.productGallery)
      return;

    this.handleIntersectionObserser();
  };

  handleIntersectionObserser = () => {
    const options = {
      root: null,
      rootMargin: '-300px 0px 0px 0px',
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.moreInfoText.classList.remove(this.moreInfoHideSelector);
          this.moreInfoImage.classList.add(this.moreInfoHideSelector);
        } else {
          this.moreInfoText.classList.add(this.moreInfoHideSelector);
          this.moreInfoImage.classList.remove(this.moreInfoHideSelector);
        }
      });
    }, options);

    observer.observe(this.productGallery);
  };
}

;// ./src/js/ContentOverMedia.js
class ContentOverMedia {
  constructor() {
    this.contentOverMediaSelector = '.content-over-media';
    this.readMoreSelector = '.content-over-media__read-more';
    this.textSelector = '.content-over-media__text';
    this.maxLength = 800;
  }

  init() {
    this.contentOverMedia = document.querySelectorAll(
      this.contentOverMediaSelector
    );
    if (!this.contentOverMedia.length > 0) return;

    this.contentOverMedia.forEach((contentOverMedia) => {
      this.readMore = contentOverMedia.querySelector(this.readMoreSelector);
      this.text = contentOverMedia.querySelector(this.textSelector);

      if (!this.readMore || !this.text) return;

      this.fullText = this.text.innerHTML.trim();

      if (this.fullText.length > this.maxLength) {
        this.truncateText();
        this.readMore.style.display = 'inline-block';
      } else {
        this.readMore.style.display = 'none';
      }

      this.readMore.addEventListener('click', () => {
        if (
          this.text.classList.contains('content-over-media__text--truncate')
        ) {
          this.text.innerHTML = this.fullText;
          this.text.classList.remove('content-over-media__text--truncate');
          this.readMore.textContent = this.readMore.dataset.readless;
        } else {
          this.truncateText();
          this.text.classList.add('content-over-media__text--truncate');
          this.readMore.textContent = this.readMore.dataset.readmore;
        }
      });
    });
  }

  truncateText() {
    let truncated = this.fullText.slice(0, this.maxLength);
    truncated = truncated.slice(0, truncated.lastIndexOf(' ')) + '...';
    this.text.innerHTML = truncated;
    this.text.classList.add('content-over-media__text--truncate');
  }
}

;// ./src/js/Accordion.js
class Accordion {
  constructor() {
    this.accordionRefSelector = '.accordion__table-cell--ref';
  }

  init = () => {
    this.accordionRef = document.querySelector(this.accordionRefSelector);

    if (!this.accordionRef) return;

    document.addEventListener('variant:change', (event) => {
      if (event.detail.variant.sku) {
        this.accordionRef.textContent = event.detail.variant.sku;
      }
    });
  };
}

;// ./src/main.js






// JS goes here
window.addEventListener('load', () => {
  const classes = [
    new Map(),
    new ProductInfo(),
    new ContentOverMedia(),
    new Accordion(),
  ];
  classes.forEach((classe) => classe.init());
});

/******/ })()
;